import { REFUND_CREDIT_CARD_STATE } from './constants'

export const getStatus = state => state[REFUND_CREDIT_CARD_STATE].status
